jQuery(function ($) {
    // Mobile Menu
    $("#h-toggle-btn, .m-overlay-bg, .h-close-icon").on("click", function (e) {
        e.preventDefault();

        $("#wrapper").toggleClass("toggled");
        $(".h-toggle-btn").toggleClass("open");
        $("#h-sidebar-wrapper").toggleClass("h-menu-active");
        $(".m-overlay-bg").toggleClass("h-bg-active");
        $("body").toggleClass("open-nav");
    });
     // Open Search
    $(document).on("click", ".h-search-icon", function (e) {
        e.preventDefault();
        $(".search-popup").addClass("active");
    });

    // Close Search
    $(document).on("click", ".close-search, .search-back-drop", function (e) {
        e.preventDefault();
        $(".search-popup").removeClass("active");
    });

    // ESC
    $(document).on("keyup", function (e) {
        if (e.key === "Escape") {
            $(".search-popup").removeClass("active");
        }
    });
   
    $(document).on("keyup", function (e) {
        if (e.key === "Escape") {
            $(".header-wapper").removeClass("moblie-search-active");
        }
    }); 
    $('.quickbuy-toggle').on('click', function () {
        var pr_list_height = $(this).closest('.product-list').find('.icon-product-card .block-inner').height();
        const pr_total_height = pr_list_height + 40;
        $(this).closest('.product-list').find('.icon-product-card .block-inner').css('height', pr_total_height + 'px');
    });
    $(document).on('click', '.close-detail', function () {
        $('.icon-product-card .block-inner').css('height', '');
    });
    $(document).on('click','.icon-product-card', function () {
        $('.icon-product-card').not(this).removeClass('icon-click');
        $(this).toggleClass('icon-click');
    });
    // mobile menu
    function mobileMenu() {
        if ($(window).width() <= 1199) {
            $(".h-dropdown-icon").off("click").on("click", function () {
                var li = $(this).parent("li");
                $("li").not(li).removeClass("open");
                li.toggleClass("open");
            });
        } else {
            $(".h-dropdown-icon").off("click");
            $("li").removeClass("open");
        }
    }
 
    mobileMenu();
    $(window).resize(function () {
        mobileMenu();
    });
});
